<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-14 09:44:57
-->
<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="首页" name="first"
        ><lectureHall
          :liveFillData="liveFillData"
          :liveFill="liveFill"
        /><activity
          :activityFillData="activityFillData"
          :activityFill="activityFill"
        />
        <enterprises :entPolicies="entPolicies" />
      </el-tab-pane>
      <el-tab-pane label="诉求走访" name="second"><appealVisit /></el-tab-pane>
      <el-tab-pane
        label="
五企培育"
        name="third"
        ><entCultivation
      /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import lectureHall from './components/lectureHall.vue'
import activity from './components/activity.vue'
import enterprises from './components/enterprises.vue'
import appealVisit from './components/appealVisit.vue'
import entCultivation from './components/entCultivation.vue'
import { fillList, fillStatusList } from '@api/dataMaintenance/dataMaintenance'
export default {
  components: {
    lectureHall,
    activity,
    enterprises,
    appealVisit,
    entCultivation
  },
  data() {
    return {
      activeName: 'first',
      liveFillData: [],
      activityFillData: [],
      entPolicies: [],
      liveFill: false,
      activityFill: false
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getFillList()
    this.fillStatusList()
  },
  mounted() {},
  methods: {
    getFillList() {
      fillList().then((res) => {
        if (res.data.code == '0000') {
          this.liveFillData = res.data.data.liveFillData
          this.activityFillData = res.data.data.activityFillData
          this.entPolicies = res.data.data.entPolicies
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    fillStatusList() {
      fillStatusList().then((res) => {
        if (res.data.code == '0000') {
          this.liveFill = res.data.data.liveFill == 1
          this.activityFill = res.data.data.activityFill == 1
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  overflow: auto;
}
</style>
